import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Sidebar from "./Sidebar";

const HeaderComponent = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  // 링크이동
  const smartStorePage = () => {
    window.open("https://smartstore.naver.com/throo", "_blank");
  };

  return (
    <Style>
      <div className="headerWrap">
        <Link to="/">
          <img
            src={`${process.env.PUBLIC_URL}/svg/logo.svg`}
            alt="behind 로고"
            className="behindLogo"
          />
        </Link>
        <div className="movePathWrap">
          {/* <button>COMPANY</button> */}
          <button onClick={() => navigate("/service")}>SERVICE</button>
          <button onClick={smartStorePage}>STORE</button>
          <button onClick={() => navigate("/contact")}>CONTACT US</button>
        </div>
        <button className="hameburgerBar" onClick={toggle}>
          <img
            src={`${process.env.PUBLIC_URL}/svg/hamburgerbar.svg`}
            alt="사이드바 열기 버튼"
          />
        </button>
      </div>
      {isOpen && <Sidebar toggle={toggle} />}
    </Style>
  );
};
export default HeaderComponent;

const Style = styled.div`
  .hameburgerBar {
    display: none;
  }
  /* headerWrap */
  .headerWrap {
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 120px 11px 50px;
    z-index: 999;
    background: #fff;

    img {
      width: 80px;
    }
  }

  /* movePathWrap */
  .movePathWrap {
    width: auto;
    display: flex;
    gap: 71px;

    button {
      padding: 11px 10px;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
  }

  @media (max-width: 1100px) {
    .movePathWrap {
      display: none;
    }
    .hameburgerBar {
      display: block;

      img {
        width: 100%;
        max-width: 32px;
        height: 32px;
      }
    }
    .headerWrap {
      padding: 13px 25px;

      img {
        width: 54px;
      }
    }
  }
`;
